import gql from 'graphql-tag';

export const autoSetupCesMutation = gql`
  mutation AutoSetupCES($request: AutoSetupCesEntityRequest!) {
    autoSetupCES(request: $request) {
      success
      message
    }
  }
`;
